import React from 'react'
import SocialNetworksForm, {
    SocialNetworksFormState,
} from 'components/forms/establishment/socialNetworksForm'
import EstablishmentCreateView from './establishmentCreateView'
import SignUpContent from 'components/layouts/components/signUpContent'
import SignUpActions from 'components/layouts/components/signUpActions'
import SubmitButton from 'components/common/submitButton'
import clsx from 'clsx'
import { useStyles } from './styles.css'
import { Typography } from '@material-ui/core'
import { Trans } from 'react-i18next'

interface Props {
    step: number
    steps: number
    onSubmit: (values: SocialNetworksFormState) => void
    inProgress: boolean
    initialValues: SocialNetworksFormState
    onPrevious: () => void
    previousInProgress: boolean
}

const EstablishmentSocialNetworksView: React.FC<Props> = ({
    step,
    steps,
    onPrevious,
    previousInProgress,
    inProgress,
    ...formData
}) => {
    const classes = useStyles()

    return (
        <SocialNetworksForm inProgress={inProgress} {...formData}>
            {(content, actions) => (
                <>
                    <SignUpContent>
                        <EstablishmentCreateView step={step} steps={steps}>
                            <Typography variant="h1" color="textSecondary" className={classes.title}>
                                <Trans i18nKey="views.establishment.socialNetworks.title" />
                            </Typography>
                            {content}
                        </EstablishmentCreateView>
                    </SignUpContent>
                    <SignUpActions>
                        <SubmitButton
                            variant="contained"
                            onClick={onPrevious}
                            loading={previousInProgress}
                            disabled={inProgress}
                        >
                            <Trans i18nKey="actions.previous" />
                        </SubmitButton>

                        {actions.map((action, index) => (
                            <SubmitButton
                                key={index}
                                variant="contained"
                                color="primary"
                                {...action}
                                className={clsx(action.className)}
                            />
                        ))}
                    </SignUpActions>
                </>
            )}
        </SocialNetworksForm>
    )
}

export default EstablishmentSocialNetworksView
